// extracted by mini-css-extract-plugin
export default {"joinNowButton":"join-now_joinNowButton"};